export default "__VITE_ASSET__CE7_q3D1__"